<template>
  <div class="main">
    <Form/>
  </div>
</template>

<script>
import Form from "@/views/Form";
export default {
  name: 'Main',
  components: {
    Form
  },
  data: () => ({
    new: false
  }),
  computed: {
  },
  methods: {
  }
};
</script>

<style scoped>

</style>
